/* eslint max-classes-per-file: 0 */

import {
  Publication as Data,
  PublicationCollection as Collection,
} from '@/typings/api/Publication'
import { PublicationsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PublicationsTransformerParams extends TransformerParams {
  public getAll(payload: Record<string, unknown>, rawParams: Record<string, unknown>) {
    const result = super.getAll(payload, rawParams)
    const p = result.params as Record<string, Record<string, unknown>>

    const params = {
      ...p,

      is_archived: p.is_archived?.value,
    }

    return { ...result, params }
  }
}

export class PublicationsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationsTransformerParams();

  public archive(id: Data['id'], config = {}, options = {}) {
    return this.api.archive(id, config, options)
  }

  public copy(id: Data['id'], config = {}, options = {}) {
    return this.api.copy(id, config, options)
  }
}
